export default __webpack_public_path__ + "static/media/Success.0f42ac0e.png";